import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from "@/common/helper";
import navbarStore from '@/store/navbar';
import { isStringEmpty } from '@shared/utils';
import { useMemo } from 'react';
import { getFixedRenewData } from '@shared/store/chat';
import { ACCEPT_IMG_TYPE, ALL_FILE_ICONS, FILE_ICONS, MAX_KNOWLEDGE_DISPLAY_COUNT, MAX_FILE_DISPLAY_COUNT } from '../input-file/shared';
import { formatFileSize } from "@shared/utils/file";
import "./UserMessage.scss";
import globalStore from '@/store/global';
import fileStore from '@/store/chat/fileStore';
import AppCheckBox from '@/ui/checkbox';
import checkStore from '@/store/checkStore';
import KnowledgeCard from '../input-file/KnowledgeCard';
import useIsAiso from '@/hooks/useIsAiso';
import { SVGPureIcon } from '@/ui';
import AISoTitle from './AISoTitle';
import chatStoreManager from '@/store/chat/manager';
import EditableText from './text-editor';
import EditableTextNext from './text-editor/next';


const UserMessage = observer((props) => {
  const store = chatStoreManager.current;
  const {
    index,
    msg_id,
    role_id,
    prompt : question,
    page = [],
    txt,
    compare_parent_id,
    role_biz,
    file,
    dataset_info,
    status,
    clone,
    handleSend,
  } = props;

  const llmInfo = navbarStore.chatModels[role_id] || {};
  const isMcpAgent = store?.mcpStore.isMcpAgent;
  const pageInfo = useMemo(() => {
    const { page } = getFixedRenewData(props);
    if(!page){
      return null;
    }
    return page[0];
  }, [page]);
  const isAiso = useIsAiso();
  // Mcp 智能体时修改为：是否为文件、图片类型消息，不再判断 biz，由 file 数据决定
  const fileInfo = useMemo(() => {
    if (file && file.length > 1) {
      file.forEach(f => {
        f.statusText = fileStore.fileStatusMap[f.md5] || ''
      })
      return file
    }
    return file?.[0];
  }, [file]);
  const [folded, setFolded] = useState(true);
  const toggleFolded = () => {
    setFolded(v => !v);
  }
  const isTyping = useMemo(() => {
    return chatStoreManager.current.isAITyping
  }, [chatStoreManager.current.isAITyping]);

  return (
    <div className={`relative rounded-16px ${clone ? "px-24px" : ""} ${(checkStore.getChecked(`${msg_id}-p`) && !clone) ? "bg-[rgba(0,0,0,0.03)]" : ""}`}>
      {
        checkStore.data.isShowCheck && !clone
        ? <AppCheckBox 
            className="absolute top-[50%] transform -translate-y-[50%] -left-24px cursor-pointer w-16px h-16px" 
            checked={checkStore.getChecked(`${msg_id}-p`)} 
            onClick={() => {
              const checked = checkStore.getChecked(`${msg_id}-p`)
              checkStore.setChecked(`${msg_id}-p`, !checked)
              checkStore.setChecked(`${msg_id}-r`, !checked)
              if(checkStore.data.checkList.length < 2 * store.messageList.length) return
              checkStore.setData({
                allChecked: checkStore.data.checkList.every(item => item.checked)
              })
            }}
          />
        : null
      }
      {
        compare_parent_id
        ? (
          <section className="flex justify-end items-center text-14px leading-20px text-primary">
            <div className="opacity-50">您请求</div>
            <div className="font-bold mx-6px opacity-90">@{llmInfo?.title || ''}</div>
            <div className="opacity-50">再次回复</div>
          </section>
        )
        : (
          <>
            {
              status == -1
              ? null
              : [
                "summary_page",
                "page",
                "page_mind",
                "summary_video",
              ].includes(role_biz) && pageInfo?.title
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-16px">
                  <a
                    className="block px-[16px] py-[8px] hover:bg-secondary rounded-[16px] cursor-pointer text-[12px] !text-primary !text-opacity-40"
                    onClick={
                      () => {
                        store.log({
                          action : "click",
                          arrt : "aibot_plugin_sidebar_summaryweb_info",
                          ext : pageInfo.title,
                          ext1 : pageInfo.url,
                          message_id : msg_id,
                          role_id,
                        });
                      }
                    }
                    href={pageInfo.url}
                    target='_blank'
                  >
                    <div 
                      className="user-referer-link w-auto max-w-[240px] line-clamp-4 border-l-[4px] border-black-6 pl-[16px] text-primary text-[15px] leading-[24px]"
                      onCopy={HelperCore.handleTrimCopy}>
                      {(pageInfo.title || "").slice(0, 200)}
                    </div>
                  </a>
                </section>
              )
              : [
                "explain",
                "translation",
                "rewrite"
              ].includes(role_biz) && txt?.content
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-16px">
                  <span
                    className="block px-[16px] py-[8px] hover:bg-secondary rounded-[16px] text-[12px] !text-primary !text-opacity-40"
                  >
                    <div 
                      className="w-auto max-w-[240px] border-l-[4px] border-black-6 pl-[16px] text-[15px] leading-[24px] whitespace-pre-wrap break-all"
                      onCopy={HelperCore.handleTrimCopy}>
                      {txt.content.slice(0, 200)}
                    </div>
                  </span>
                </section>
              )
              : (
                fileInfo?.url 
                && file?.length == 1
                && ACCEPT_IMG_TYPE.some(_ => fileInfo.url.toLowerCase().includes(_))
              )
              ? (
                <section className="flex flex-col mt-[14px] items-end mb-[8px]">
                  <img src={fileInfo.url} className='max-w-[200px] max-h-[200px] rounded-[16px] border-[1px] border-solid border-black border-opacity-5' />
                </section>
              )
              : (
                fileInfo?.ext && 
                ALL_FILE_ICONS[fileInfo.ext] && 
                !Array.isArray(fileInfo)
              )
              ? (
                <div className='w-full flex justify-end'>
                  <section className="w-[200px] h-[50px] flex flex-col mt-[14px] items-end mb-[8px]">
                    <div className={[
                      "w-full flex items-center border-[1px] border-solid px-[12px] py-[10px] rounded-[16px]",
                      globalStore.isDark ? 'border-white border-opacity-10' : 'border-black border-opacity-10'
                    ]}>
                      <img src={ ALL_FILE_ICONS[fileInfo.ext]} className='size-32px mr-[8px] rounded-8px' />
                      <div className="w-[145px]">
                        <div className="w-full text-[12px] leading-[16px] pr-10px font-bold text-primary-opacity text-opacity-80 truncate">
                          {fileInfo.title}
                        </div>
                        <div className="flex items-center text-[12px] leading-[16px] text-primary-opacity text-opacity-50">
                          <span className='max-w-[90px] truncate'>{fileInfo.statusText === '解析完成' ? '' : fileInfo.statusText}</span><span>{formatFileSize(fileInfo.size)}</span>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              )
              : (
                // [
                //   "doc",
                // ].includes(role_biz) && 
                Array.isArray(fileInfo)
              )
              ? (
                <div className='flex flex-row flex-wrap justify-end gap-[8px] mt-[14px]'>
                  {
                    fileInfo.map((file, index) => {
                      if (
                        !(
                          file 
                          && file.ext 
                          // && ALL_FILE_ICONS[file.ext]
                        )
                      ) return null
                      if(index >= MAX_FILE_DISPLAY_COUNT - 1 && folded){
                        return null;
                      }
                      return (
                        <section className="w-[200px] flex flex-col items-end " key={index + file.url}>
                          <div className={[
                            "w-full flex items-center border-[1px] border-solid px-[12px] py-[10px] rounded-[12px] bg-white",
                            'border-black border-opacity-10',
                          ]}>
                            <img src={ ALL_FILE_ICONS[file.ext] || file.url } className='size-32px mr-[8px] rounded-8px' />
                            <div className="w-[145px]">
                              <div className="w-full text-[12px] leading-[16px] pr-10px font-bold text-primary-opacity text-opacity-80 truncate">
                                {file.title}
                              </div>
                              <div className="flex items-center text-[12px] leading-[16px] text-primary-opacity text-opacity-50">
                                <span className="max-w-[90px] truncate">{file.statusText}</span><span>{formatFileSize(file.size)}</span>
                              </div>
                            </div>
                          </div>
                      </section>
                      )
                    })
                  }
                  {
                    fileInfo.length > MAX_FILE_DISPLAY_COUNT && folded
                    ? (
                      <div 
                        className="flex items-center gap-[8px]"
                        onClick={toggleFolded}>
                        <section
                          className={[
                            'relative',
                            'group',
                            'w-200px',
                            'rounded-[12px] bg-white border',
                            'py-[8px] px-[10px]',
                            'flex gap-[8px]',
                            'text-[12px] leading-snug cursor-pointer',
                            'border-[rgba(0,0,0,.1)]'
                          ]}
                        >
                          <div className="size-32px rounded-full flex items-center justify-center bg-[#F0F0F0]">
                            <SVGPureIcon name="more" />
                          </div>
                          <section className="flex flex-col overflow-hidden">
                            <span className="text-primary-opacity text-opacity-80 font-bold truncate">展开全部文件</span>
                            <span className="text-primary-opacity text-opacity-50">
                              {fileInfo.length - (MAX_FILE_DISPLAY_COUNT - 1)}个文件
                            </span>
                          </section>
                        </section>
                      </div>
                    )
                    : null
                  }
                </div>
              ) 
              : dataset_info && false
              ? (
                <div className='flex flex-row flex-wrap justify-end gap-[8px] mt-[14px]'>
                  {
                    Object.keys(dataset_info).slice(0, MAX_KNOWLEDGE_DISPLAY_COUNT).map(id => {
                      const info = dataset_info[id];
                      return (
                        <KnowledgeCard key={id} info={info} />
                      )
                    })
                  }
                  {
                    Object.keys(dataset_info).length > MAX_KNOWLEDGE_DISPLAY_COUNT
                    ? (
                      <KnowledgeCard key="more" count={Object.keys(dataset_info).length - MAX_KNOWLEDGE_DISPLAY_COUNT} />
                    )
                    : null
                  }
                </div>
              )
              : null
            }
            {
              !isStringEmpty(question) 
              ? (
                isAiso 
                // 从第二条开始，气泡显示
                && index == 0
                ? (
                  <EditableText
                    disabled={isTyping}
                    initalText={question}
                    submit={(nextText) => {
                      // 追问
                      if (!nextText) return
                      handleSend({
                        value: nextText.trim(),
                      })
                    }}
                  >
                    <AISoTitle question={question} />
                  </EditableText>
                )
                : (
                  <EditableTextNext
                    disabled={isTyping}
                    initalText={question}
                    submit={(nextText) => {
                      // 追问
                      if (!nextText) return
                      handleSend({
                        value: nextText.trim(),
                      })
                    }}
                  >
                    <p
                      onCopy={HelperCore.handleTrimCopy}
                      className={[
                        'max-w-[80%] bg-[#333]',
                        'rounded-12px',
                        'px-[16px] py-[10px] mt-[8px] mb-[8px]',
                        'text-white text-[15px] leading-[22px]',
                        'whitespace-pre-line break-all overflow-x-hidden',
                      ]}
                    >
                      {question}
                    </p>
                  </EditableTextNext>
                )
              )
              : null
            }
          </>
        )
      }
    </div>
  )
});
export default UserMessage;